import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import LandingPage from "./Components/LandingPage/LandingPage";
import Projects from './Components/Projects/Projects';

export default class Routes extends Component {
  render() {
    return (
        <Router>
          <div className="App">
            <Switch>
              <Route exact path='/' component={LandingPage} />
              <Route exact path='/projects' component={Projects} />
            </Switch>
          </div>
        </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes.js